module.exports = __webpack_public_path__ + "img/share-icon-music.8d01fd78.svg";